/**
 * PFM API Service
 *
 * Calls the backend proxy endpoint which forwards to the external PFM API.
 * Credentials are stored server-side, not in the frontend.
 */

import { httpClient } from './http-client.service';
import type { PFMSDKInitRequest, PFMSDKInitResponse } from '../types/pfm';

class PFMApiService {
  /**
   * Initialize PFM SDK session via backend proxy.
   * Returns a session_token used to launch the PFM journey.
   */
  async initSDK(payload: PFMSDKInitRequest): Promise<PFMSDKInitResponse> {
    const response = await httpClient.post<PFMSDKInitResponse>(
      '/pfm/sdk/init',
      payload,
    );
    return response.data;
  }
}

export const pfmAPI = new PFMApiService();
